import { Icon } from '@eventbrite/eds-icon';
import { NegativeIconFill } from '@eventbrite/eds-iconography';
import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import RebrandingAlertCircleIcon from '../../../resources/rebranding-alert-circle-icon';
import {
    DEFAULT_STYLES,
    getStyles,
    REBRANDING_STYLES,
} from '../../../utils/rebrand';

import defaultStyles from './SeriesNotification.module.scss';
import rebrandStyles from './SeriesNotification.rebranding.module.scss';

const stylesModules = {
    [DEFAULT_STYLES]: defaultStyles,
    [REBRANDING_STYLES]: rebrandStyles,
};

export interface SeriesNotificationProps {
    text: string;
    className?: string;
    isAppRebrandActive: boolean;
}

export const SeriesNotification: FunctionComponent<SeriesNotificationProps> = ({
    text,
    className,
    isAppRebrandActive,
}) => {
    const icon = isAppRebrandActive ? (
        <RebrandingAlertCircleIcon />
    ) : (
        <Icon type={<NegativeIconFill />} color="ui-red" />
    );

    const theme = getStyles(!!isAppRebrandActive);
    const styles = stylesModules[theme];

    return (
        <p
            role="polite"
            className={classNames(
                'eds-align--center-vertical eds-fx--fade-in',
                className,
                styles.validationErrorText,
                styles.eventSoldOutMessage,
            )}
            data-testid="series-notification"
        >
            <span>{icon}</span>
            {text}
        </p>
    );
};
